module.exports = __webpack_public_path__ + "img/hotel.4fe24f29.svg";